module.exports = __webpack_public_path__ + "static/media/Brihi-Joshi.e98a0edc.jpg";